import ManageUsersScreen from '../../screens/ManageUsers/ManageUsersScreen'
import * as actions from '../../actions'
import { connect } from 'react-redux'

const mapStateToProps = ({ users }) => {
  return { users }
}

const mapDispatchToProps = dispatch => {
  return {
    getUserListWithType: (userType) => dispatch(actions.getUserListWithType(userType))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsersScreen)


// WEBPACK FOOTER //
// ./src/containers/ManageUsers/ManageUsers.js